'use strict';

// Add init function that is executed on every page/fragment render
mpro.addInitStatic(async ($container) => {

	const $gallery360 = $container.find('[data-gallery-360]');

	// Init lib only if we need to
	if ($gallery360.length > 0) {

		// Disable init on script load
		if (typeof(window.CI360) === 'undefined') {
			window.CI360 = { notInitOnLoad: true };
		}

		// Load 360 gallery lib lib
		await import('js-cloudimage-360-view');

		const CI360 = window.CI360;
		CI360.destroy();
		CI360.init();

		$container.find('[data-gallery-360] canvas, [data-gallery-360] .cloudimage-360-play, [data-gallery-360] .cloudimage-360-pause').on('click.gallery-360', function(){
			const $galleryContainer = $(this).closest('[data-gallery-360]');

			if ($galleryContainer.prop('id') && $galleryContainer.is('[data-disable-drag]')) {
				const galleryInstance = CI360._viewers.filter(viewer => viewer.id === $galleryContainer.prop('id'))[0];

				if (!galleryInstance.playing) {
					galleryInstance.play();
				}
				else {
					galleryInstance.stop();
				}

				galleryInstance.playing = !galleryInstance.playing;
				$galleryContainer.find('.cloudimage-360-play, .cloudimage-360-pause').toggle();
			}
		});

		// // Add play / pause functionality
		// $gallery360.each(function(){
		// 	const $galleryContainer = $(this);
		// 	if ($galleryContainer.prop('id') && $galleryContainer.is('[data-disable-drag]')) {
		// 		const galleryInstance = CI360._viewers.filter(viewer => viewer.id === $galleryContainer.prop('id'))[0];
		//
		// 		$galleryContainer.on('click', '.cloudimage-360-play', function(){
		// 			galleryInstance.play();
		// 			$galleryContainer.find('.cloudimage-360-play, .cloudimage-360-pause').toggle();
		// 		});
		// 		$galleryContainer.on('click', '.cloudimage-360-pause', function(){
		// 			galleryInstance.stop();
		// 			$galleryContainer.find('.cloudimage-360-play, .cloudimage-360-pause').toggle();
		// 		});
		//
		// 		// $galleryContainer.on('click', 'canvas', function(e){
		// 		// 	if (this.dataset.loopTimeoutId === galleryInstance.loopTimeoutId && typeof(galleryInstance.loopTimeoutId) !== 'undefined') {
		// 		// 		galleryInstance.stop();
		// 		// 	}
		// 		// 	else {
		// 		// 		galleryInstance.play();
		// 		// 	}
		// 		// 	console.log(galleryInstance.loopTimeoutId);
		// 		// 	// if ($galleryContainer.find('.cloudimage-360-play').is(':visible')) {
		// 		// 	// 	galleryInstance.play();
		// 		// 	// }
		// 		// 	// else {
		// 		// 	// 	galleryInstance.stop();
		// 		// 	// }
		// 		//
		// 		// 	$galleryContainer.find('.cloudimage-360-play, .cloudimage-360-pause').toggle();
		// 		//
		// 		// 	this.dataset.loopTimeoutId = galleryInstance.loopTimeoutId;
		// 		// });
		// 	}
		// });
	}
});
